import { Injectable } from '@angular/core';
import { ShepherdService } from 'angular-shepherd';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Overlay } from '@fb-tool-front/shared/interfaces/catalogs.type';
import { TranslateService } from '@ngx-translate/core';
import { LocaleService } from './locale.service';
import { filter, switchMap, take, tap } from 'rxjs/operators';

const SVG_SETTINGS = `
<svg style="width: 16px; height: 16px; vertical-align: bottom;" xmlns="http://www.w3.org/2000/svg" focusable="false">
  <g id="settings" xmlns="http://www.w3.org/2000/svg" transform="translate(-8,-8)">
    <svg x="50%" y="50%">
      <svg width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.99964 8.63588C7.90337 8.63588 8.63599 7.90328 8.63599 6.99958C8.63599 6.09588 7.90337 5.36328 6.99964 5.36328C6.0959 5.36328 5.36328 6.09588 5.36328 6.99958C5.36328 7.90328 6.0959 8.63588 6.99964 8.63588Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M11.0364 8.63637C10.9638 8.80089 10.9421 8.98339 10.9742 9.16033C11.0063 9.33727 11.0906 9.50055 11.2164 9.6291L11.2491 9.66183C11.3505 9.76314 11.431 9.88346 11.4859 10.0159C11.5408 10.1483 11.569 10.2903 11.569 10.4336C11.569 10.577 11.5408 10.719 11.4859 10.8514C11.431 10.9838 11.3505 11.1042 11.2491 11.2055C11.1478 11.3069 11.0275 11.3874 10.895 11.4423C10.7626 11.4972 10.6206 11.5254 10.4773 11.5254C10.3339 11.5254 10.192 11.4972 10.0595 11.4423C9.92709 11.3874 9.80677 11.3069 9.70545 11.2055L9.67273 11.1727C9.54418 11.047 9.3809 10.9626 9.20396 10.9306C9.02701 10.8985 8.84452 10.9201 8.68 10.9927C8.51867 11.0619 8.38108 11.1767 8.28417 11.323C8.18725 11.4694 8.13525 11.6409 8.13455 11.8164V11.9091C8.13455 12.1984 8.01961 12.4759 7.81503 12.6805C7.61044 12.8851 7.33296 13 7.04364 13C6.75431 13 6.47683 12.8851 6.27225 12.6805C6.06766 12.4759 5.95273 12.1984 5.95273 11.9091V11.86C5.9485 11.6795 5.89006 11.5044 5.78501 11.3575C5.67995 11.2106 5.53313 11.0987 5.36364 11.0364C5.19912 10.9638 5.01662 10.9421 4.83968 10.9742C4.66274 11.0063 4.49946 11.0906 4.37091 11.2164L4.33818 11.2491C4.23687 11.3505 4.11655 11.431 3.98412 11.4859C3.85168 11.5408 3.70973 11.5691 3.56636 11.5691C3.423 11.5691 3.28104 11.5408 3.14861 11.4859C3.01618 11.431 2.89586 11.3505 2.79455 11.2491C2.69312 11.1478 2.61265 11.0275 2.55775 10.895C2.50285 10.7626 2.4746 10.6206 2.4746 10.4773C2.4746 10.3339 2.50285 10.192 2.55775 10.0595C2.61265 9.9271 2.69312 9.80678 2.79455 9.70546L2.82727 9.67274C2.95302 9.54419 3.03737 9.38091 3.06946 9.20397C3.10154 9.02702 3.07988 8.84453 3.00727 8.68001C2.93813 8.51868 2.82332 8.38109 2.67698 8.28418C2.53064 8.18726 2.35916 8.13525 2.18364 8.13455H2.09091C1.80158 8.13455 1.52411 8.01962 1.31952 7.81503C1.11493 7.61045 1 7.33297 1 7.04364C1 6.75432 1.11493 6.47684 1.31952 6.27225C1.52411 6.06767 1.80158 5.95273 2.09091 5.95273H2.14C2.32054 5.94851 2.49564 5.89007 2.64253 5.78501C2.78941 5.67995 2.9013 5.53313 2.96364 5.36364C3.03624 5.19912 3.0579 5.01663 3.02582 4.83968C2.99374 4.66274 2.90938 4.49947 2.78364 4.37091L2.75091 4.33819C2.64948 4.23687 2.56902 4.11655 2.51412 3.98412C2.45922 3.85169 2.43096 3.70973 2.43096 3.56637C2.43096 3.423 2.45922 3.28105 2.51412 3.14861C2.56902 3.01618 2.64948 2.89586 2.75091 2.79455C2.85223 2.69312 2.97254 2.61265 3.10497 2.55775C3.23741 2.50286 3.37936 2.4746 3.52273 2.4746C3.66609 2.4746 3.80805 2.50286 3.94048 2.55775C4.07291 2.61265 4.19323 2.69312 4.29455 2.79455L4.32727 2.82727C4.45583 2.95302 4.6191 3.03738 4.79604 3.06946C4.97299 3.10154 5.15548 3.07988 5.32 3.00728H5.36364C5.52497 2.93813 5.66255 2.82332 5.75947 2.67698C5.85638 2.53064 5.90839 2.35916 5.90909 2.18364V2.09091C5.90909 1.80158 6.02403 1.52411 6.22861 1.31952C6.4332 1.11493 6.71067 1 7 1C7.28933 1 7.5668 1.11493 7.77139 1.31952C7.97597 1.52411 8.09091 1.80158 8.09091 2.09091V2.14C8.09161 2.31552 8.14362 2.48701 8.24053 2.63335C8.33745 2.77969 8.47504 2.8945 8.63636 2.96364C8.80088 3.03625 8.98338 3.05791 9.16032 3.02582C9.33726 2.99374 9.50054 2.90939 9.62909 2.78364L9.66182 2.75091C9.76313 2.64948 9.88345 2.56902 10.0159 2.51412C10.1483 2.45922 10.2903 2.43096 10.4336 2.43096C10.577 2.43096 10.719 2.45922 10.8514 2.51412C10.9838 2.56902 11.1041 2.64948 11.2055 2.75091C11.3069 2.85223 11.3873 2.97254 11.4422 3.10498C11.4971 3.23741 11.5254 3.37937 11.5254 3.52273C11.5254 3.66609 11.4971 3.80805 11.4422 3.94048C11.3873 4.07292 11.3069 4.19323 11.2055 4.29455L11.1727 4.32728C11.047 4.45583 10.9626 4.6191 10.9305 4.79605C10.8985 4.97299 10.9201 5.15549 10.9927 5.32001V5.36364C11.0619 5.52497 11.1767 5.66256 11.323 5.75947C11.4694 5.85639 11.6408 5.9084 11.8164 5.9091H11.9091C12.1984 5.9091 12.4759 6.02403 12.6805 6.22862C12.8851 6.4332 13 6.71068 13 7.00001C13 7.28933 12.8851 7.56681 12.6805 7.7714C12.4759 7.97598 12.1984 8.09092 11.9091 8.09092H11.86C11.6845 8.09162 11.513 8.14363 11.3667 8.24054C11.2203 8.33745 11.1055 8.47504 11.0364 8.63637V8.63637Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </svg>
  </g>
</svg>
`;

@Injectable({
  providedIn: 'root'
})
export class TourService {
  tourInitializing$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  tourCompleted$$: Subject<void> = new Subject();
  tourCompleted$: Observable<void> = this.tourCompleted$$.asObservable();

  tourCanceled$$: Subject<void> = new Subject();
  tourCanceled$: Observable<void> = this.tourCanceled$$.asObservable();

  tourShow$$: Subject<void> = new Subject();
  tourShow$: Observable<void> = this.tourShow$$.asObservable();

  private readonly onTourCompleteCallback = this.onTourComplete.bind(this);
  private readonly onTourCancelCallback = this.onTourCancel.bind(this);
  private readonly onTourShowCallback = this.onTourShow.bind(this);

  constructor(
    private shepherdService: ShepherdService,
    private translateService: TranslateService,
    private localeService: LocaleService
  ) {}

  get isActive(): boolean {
    return this.shepherdService.isActive;
  }

  get isInitialized(): boolean {
    return !!this.shepherdService.tourObject;
  }

  private clearListeners(): void {
    this.shepherdService.tourObject?.off('complete', this.onTourCompleteCallback);
    this.shepherdService.tourObject?.off('cancel', this.onTourCancelCallback);
    this.shepherdService.tourObject?.off('show', this.onTourShowCallback);
  }

  onTourShow(): void {
    this.tourShow$$.next();
  }

  onTourComplete(): void {
    this.tourCompleted$$.next();
  }

  onTourCancel(event): void {
    this.tourCanceled$$.next();
  }

  getCurrentStep() {
    return this.shepherdService.tourObject?.getCurrentStep();
  }

  start(): void {
    this.tourInitializing$
      .pipe(
        filter(loading => !loading),
        take(1)
      )
      .subscribe(() => {
        if (!this.shepherdService.tourObject.isActive()) {
          this.shepherdService.start();
        }
      });
  }

  stop(): void {
    this.shepherdService.isActive && this.shepherdService.cancel();
    this.clearListeners();
  }

  initOverlaysTour([overlayItems, overlays]: [Overlay[], Overlay[]]): void {
    this.tourInitializing$.next(true);
    this.localeService.localeLoading$
      .pipe(
        filter(loading => !loading),
        take(1),
        tap(() => {
          const isCreateOverlayStepShown =
            overlayItems?.length || (overlays?.length === 0 && overlayItems?.length === 0);
          const hasOverlays = overlayItems?.length && overlays?.length;

          this.shepherdService.defaultStepOptions = {
            classes: 'ait-shepherd',
            scrollTo: false,

            when: {
              show() {
                const currentStepElement = this.tour.currentStep.el;
                const footer = currentStepElement.querySelector('.shepherd-footer');
                const progress = document.createElement('span');
                progress.style['margin-right'] = 'auto';
                progress.style['align-self'] = 'center';
                progress.innerText = `${this.tour.steps.indexOf(this.tour.currentStep) + 1}/${
                  this.tour.steps.length
                }`;
                footer.insertBefore(progress, footer.firstChild);
              }
            }
          };
          this.shepherdService.modal = true;
          this.shepherdService.confirmCancel = false;

          this.shepherdService.addSteps([
            {
              id: 'first-shepherd-element',
              attachTo: {
                element: '#first-shepherd-element',
                on: 'right-start'
              },
              popperOptions: {
                modifiers: [
                  {
                    name: 'offset',
                    options: { offset: [0, 12] }
                  }
                ]
              },
              modalOverlayOpeningRadius: 8,
              buttons: [
                {
                  classes: 'shepherd-button-primary',
                  text: this.translateService.instant('Next'),
                  type: 'next'
                }
              ],
              classes: 'ait-shepherd ait-shepherd--overlay-preview',
              highlightClass: 'highlight',
              scrollTo: false,
              title: this.translateService.instant('Check your overlay'),
              text: this.translateService.instant(
                'Please, switch the "overlay preview" toggle to check how your products look with the selected overlay.'
              )
            },
            ...(isCreateOverlayStepShown
              ? [
                  {
                    id: 'second-shepherd-element',
                    attachTo: {
                      element: '#second-shepherd-element',
                      on: 'top'
                    },
                    popperOptions: {
                      modifiers: [{ name: 'offset', options: { offset: [0, 12] } }]
                    },
                    modalOverlayOpeningRadius: 12,
                    modalOverlayOpeningPadding: 0.5,
                    buttons: [
                      {
                        classes: 'shepherd-button-secondary',
                        text: this.translateService.instant('Back'),
                        type: 'back'
                      },
                      {
                        classes: 'shepherd-button-primary',
                        text: this.translateService.instant('Next'),
                        type: 'next'
                      }
                    ],
                    classes: 'ait-shepherd',
                    highlightClass: 'highlight',
                    scrollTo: false,
                    title: this.translateService.instant('Create an overlay!'),
                    text: this.translateService.instant(
                      'Here you can work with your overlays. Just create one and apply it to all products in selected product set.'
                    ),
                    canClickTarget: false
                  }
                ]
              : []),
            ...(hasOverlays
              ? [
                  {
                    id: 'third-shepherd-element',
                    attachTo: {
                      element: '#third-shepherd-element',
                      on: 'top'
                    },
                    popperOptions: {
                      modifiers: [{ name: 'offset', options: { offset: [0, 12] } }]
                    },
                    modalOverlayOpeningRadius: 12,
                    modalOverlayOpeningPadding: 0.5,
                    buttons: [
                      {
                        classes: 'shepherd-button-secondary',
                        text: this.translateService.instant('Back'),
                        type: 'back'
                      },
                      {
                        classes: 'shepherd-button-primary',
                        text: this.translateService.instant('Next'),
                        type: 'next'
                      }
                    ],
                    classes: 'ait-shepherd',
                    highlightClass: 'highlight',
                    scrollTo: false,
                    title: this.translateService.instant('Edit overlay!'),
                    text: this.translateService.instant('You can edit selected overlay'),
                    canClickTarget: false
                  },
                  {
                    id: 'fourth-shepherd-element',
                    attachTo: {
                      element: '#fourth-shepherd-element',
                      on: 'left'
                    },
                    popperOptions: {
                      modifiers: [{ name: 'offset', options: { offset: [0, 12] } }]
                    },
                    modalOverlayOpeningRadius: 12,
                    modalOverlayOpeningPadding: 0.5,
                    buttons: [
                      {
                        classes: 'shepherd-button-secondary',
                        text: this.translateService.instant('Back'),
                        type: 'back'
                      },
                      {
                        classes: 'shepherd-button-primary',
                        text: this.translateService.instant('Got it!'),
                        type: 'next'
                      }
                    ],
                    classes: 'ait-shepherd',
                    highlightClass: 'highlight',
                    scrollTo: false,
                    title: this.translateService.instant('Apply overlay!'),
                    text: this.translateService.instant(
                      'Click here to apply your overlay to all products images in the selected product set.'
                    ),
                    canClickTarget: false
                  }
                ]
              : [])
          ]);
          this.shepherdService.tourObject['options']['exitOnEsc'] = false;

          this.shepherdService.tourObject.on('complete', this.onTourCompleteCallback);
          this.shepherdService.tourObject.on('cancel', this.onTourCancelCallback);
          this.shepherdService.tourObject.on('show', this.onTourShowCallback);
        }),
        tap(() => this.tourInitializing$.next(false))
      )
      .subscribe();
  }
}
